import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import { formatDateToMonthShort } from '@core/utils/filter'

Vue.component(FeatherIcon.name, FeatherIcon)
Vue.filter('formatDateToMonthShort', formatDateToMonthShort)
